import { PropsWithChildren, ReactNode } from 'react';
import styles from './Page.module.scss';

export interface PageProps {
  header?: ReactNode;
  nav?: ReactNode;
  fullWidth?: boolean;
}

export function Page({ header, nav, children, fullWidth = false }: PropsWithChildren<PageProps>) {
  return (
    <article
      className={`${styles.container} ${fullWidth ? styles['container--full-width'] : styles['container--breakpoints']}`}
    >
      {header && <div className={styles.headerSlot}>{header}</div>}

      {nav ? nav : null}

      {children}
    </article>
  );
}

export default Page;
